import { createAction } from '@reduxjs/toolkit';
import { AppState } from '@store/app/types';

const prefix = '@app';

export const initAppAction = createAction<Omit<AppState, 'isAppInit'>>(`${prefix}/INIT_APP`);
